import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta01Model } from './model-consultaSeguimentoPergunta01'
import {
  hasPergunta01ExemplosFalhouAnySim,
  hasPergunta01ExemplosPassouAnySim,
  isPergunta01ExemplosAllFilled,
} from './utils-consultaSeguimentoPergunta01'

export const PERGUNTA_01_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta01Model> = {
  PERGUNTA_01_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_01_EXEMPLOS',
      },
    ],
  },
  PERGUNTA_01_EXEMPLOS: {
    scrollConditions: [
      {
        if: (value) =>
          isPergunta01ExemplosAllFilled(value) &&
          !hasPergunta01ExemplosPassouAnySim(value) &&
          !hasPergunta01ExemplosFalhouAnySim(value),
        scrollTo: 'BOTTOM',
      },
      {
        if: (value) =>
          isPergunta01ExemplosAllFilled(value) &&
          hasPergunta01ExemplosPassouAnySim(value) &&
          !hasPergunta01ExemplosFalhouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta01ExemplosAllFilled(value) &&
          hasPergunta01ExemplosFalhouAnySim(value) &&
          !hasPergunta01ExemplosPassouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta01ExemplosAllFilled(value) &&
          hasPergunta01ExemplosFalhouAnySim(value) &&
          hasPergunta01ExemplosPassouAnySim(value),
        scrollTo: 'PERGUNTA_01_MAIOR_FREQUENCIA',
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_01_HEADER',
  },
  PERGUNTA_01_MAIOR_FREQUENCIA: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_01_EXEMPLOS',
  },
}
